import React, { Component } from "react";
import L from "leaflet";
import { SelectBox } from "devextreme-react/select-box";
import { LoadPanel } from "devextreme-react/load-panel";
import { axiosGet, axiosPost } from "../../apis/useAxios.js";
import { DateFormat } from "../../helpers/fixcodes";
import moment from "moment";
import { List } from "devextreme-react";
import DataSource from "devextreme/data/data_source.js";
import { toast } from "react-toastify";
import LiveTripTracking from "../map/LiveTripTracking";
import "./trackingMapTheme.css";
export class TrackingComponent extends Component {
  static displayName = TrackingComponent.name;
  constructor(props) {
    super(props);
    let transporterId = 0;
    let airportCode = "";
    let sourceUrl = "";
    if (this.props.location.state) {
      transporterId = this.props.location?.state?.transporterId ?? 0;
      airportCode = this.props.location?.state?.airportCode ?? "";
      sourceUrl = this.props.location?.state?.sourceUrl ?? "";
    }

    this.state = {
      loadPanelVisible: false,
      isSearch: false,
      airportDropdownDataSource: [],
      airportCode: airportCode,
      transporterDropdownDataSource: [],
      transporterId: transporterId,
      trackingLst: [],
      sourceUrl: sourceUrl,
      map: {
        center: { lat: 19.0936, lng: 72.856629 },
        zoom: 10,
      },
      radius: 500,
      intervalSecond: 5,
      selectedVehicle: null,
      showLiveTracking: false,
    };
    this.selectedVehicleLatLng = null;
    this.isComponentDidMounted = false;
    this.allowAutoRefresh = false;
    this.mapRef = React.createRef();
    this.listRef = React.createRef();
    this.map = null;
    this.vehicleMarkers = [];
    this.vehicleRadiusCircle = null;
    this.openPopupRideId = null;
    this.isRedrawingMarkers = false;
    this.trackingRefreshInterval = null;
    this.trackingStoreArray = [];
    // Stable references for List props: an inline array/object literal in
    // render() would be a new reference on every re-render (e.g. every time
    // selecting a vehicle calls setState), which makes DevExtreme's List
    // think its config changed and reset its scroll position/paging back to
    // the top right after the click.
    // No overflowY here: DevExtreme's List already renders its own internal
    // ScrollView with its own (custom, thin) scrollbar. Forcing overflowY on
    // this wrapper too made the *browser's* native scrollbar appear on this
    // outer div — a second, clunky scrollbar stacked on top of the widget's
    // own one. minHeight: 0 lets this flex child actually shrink so the
    // DevExtreme ScrollView inside it gets a bounded height to scroll within.
    this.listStyle = { flex: 1, minHeight: 0 };
    this.trackingListSearchExpr = [
      "vehicleNo",
      "rideId",
      "activityDisplay",
      "driverName",
      "gpsDateTime",
      "paxName",
      "employeeNo",
    ];
    this.trackingDataSource = new DataSource({
      store: {
        type: "array",
        data: this.trackingStoreArray,
        key: "rideId",
      },
      sort: ["Position", { selector: "vehicleNo", desc: true }],
      paginate: true,
      pageSize: 10,
    });
  }
  componentDidMount() {
    try {
      if (this.isComponentDidMounted) {
        return;
      }
      this.map = L.map(this.mapRef.current, {
        center: [this.state.map.center.lat, this.state.map.center.lng],
        zoom: this.state.map.zoom,
      });
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      }).addTo(this.map);
      this.fetchDataOnPageLoad();
      this.isComponentDidMounted = true;
    } catch (error) {
      console.log(error);
    }
  }
  fetchDataOnPageLoad = () => {
    try {
      setTimeout(async () => {
        await this.getAirportDropdown();
      }, 0);
      setTimeout(async () => {
        await this.getServiceProviderDropdown();
      }, 0);
      if (this.state.transporterId > 0 || !this.state.airportCode) {
        setTimeout(async () => {
          await this.getTrackingData(
            this.state.transporterId,
            this.state.airportCode,
          );
        }, 0);
      }
    } catch (error) {
      console.log(error);
    }
  };
  getAirportDropdown = async () => {
    try {
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const response = await axiosGet(
        `Airport/get-airport-dropdown/${airlineCode}`,
      );
      this.setState((prev) => ({
        ...prev,
        airportDropdownDataSource: response.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getAirportDropdown function",
        err,
      );
    }
  };
  getServiceProviderDropdown = async () => {
    try {
      const response = await axiosGet("Account/get-transport-dropdown");
      this.setState((prev) => ({
        ...prev,
        transporterDropdownDataSource: response?.payload ?? [],
      }));
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getServiceProviderDropdown function",
        err,
      );
    }
  };
  getTrackingData = async (transporterId, airportCode) => {
    try {
      clearInterval(this.trackingRefreshInterval);
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: true,
      }));
      let airlineCode = sessionStorage.getItem("session_airlineCode");
      const response = await axiosPost("Tracking", {
        AirlineCode: airlineCode,
        TransporterId: transporterId,
        AirportCode: airportCode,
        RideId: 0,
      });
      const data = response.payload ?? [];
      this.trackingStoreArray.length = 0;
      this.trackingStoreArray.push(...data);
      this.trackingDataSource.reload();
      this.setState((prev) => ({
        ...prev,
        loadPanelVisible: false,
        trackingLst: data,
      }));
      setTimeout(() => {
        this.drawVehicleMarkers();
      }, 1000);
      if (this.allowAutoRefresh === true) {
        this.trackingRefreshInterval = setInterval(async () => {
          await this.getTrackingData(
            this.state.transporterId,
            this.state.airportCode,
          );
        }, this.state.intervalSecond * 1000);
      }
    } catch (err) {
      console.log(
        "Error in " + this.displayName + ".getTrackingData function",
        err,
      );
      this.setState({
        loadPanelVisible: false,
      });
    }
  };
  getZoomLevel = (radius) => {
    let zoomLevel = 17;
    let scale = radius / 500;
    zoomLevel = 16 - Math.log(scale) / Math.log(2);
    return zoomLevel;
  };
  notifyVehicleDataNotFound = () => {
    toast.info("Location data not available for this vehicle.", {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000,
      hideProgressBar: false,
      newestOnTop: false,
      closeButton: false,
    });
  };
  openVehicleDetailPanel = (vehicle, latlng) => {
    try {
      if (!vehicle) {
        return;
      }
      this.selectedVehicleLatLng = latlng || null;
      // Only remember this rideId as "the highlighted one" when it actually
      // has a marker (a real latlng). Otherwise a later marker redraw could
      // match this rideId against some other vehicle's marker by accident
      // (e.g. if the backend ever reuses a rideId) and highlight the wrong
      // vehicle on the map instead of showing no highlight at all.
      this.openPopupRideId = latlng ? vehicle.rideId : null;
      this.setState({ selectedVehicle: vehicle, showLiveTracking: false });
      if (latlng) {
        this.showVehicleRadiusCircle(latlng);
      } else {
        // This vehicle has no GPS fix — clear any circle left over from a
        // previously selected vehicle instead of leaving it pinned on that
        // other vehicle's position. The info bar itself shows a "location
        // not found" banner (see renderVehicleDetailPanel) instead of a toast.
        this.clearVehicleRadiusCircle();
      }
    } catch (error) {
      console.log(error);
    }
  };
  closeVehicleDetailPanel = () => {
    try {
      const latlng = this.selectedVehicleLatLng;
      this.openPopupRideId = null;
      this.selectedVehicleLatLng = null;
      this.clearVehicleRadiusCircle();
      this.setState({ selectedVehicle: null, showLiveTracking: false });
      if (latlng && this.map) {
        this.map.panTo(latlng);
        this.map.setZoom(12);
      }
    } catch (error) {
      console.log(error);
    }
  };
  openLiveTracking = () => {
    this.setState({ showLiveTracking: true });
  };
  closeLiveTracking = () => {
    this.setState({ showLiveTracking: false });
  };
  showVehicleRadiusCircle = (latlng) => {
    try {
      this.clearVehicleRadiusCircle();
      this.vehicleRadiusCircle = L.circle(latlng, {
        radius: 50,
        color: "#095590",
        weight: 1.5,
        fillColor: "#095590",
        fillOpacity: 0.12,
      }).addTo(this.map);
    } catch (error) {
      console.log(error);
    }
  };
  clearVehicleRadiusCircle = () => {
    try {
      if (this.vehicleRadiusCircle) {
        this.vehicleRadiusCircle.remove();
        this.vehicleRadiusCircle = null;
      }
    } catch (error) {}
  };
  centerAndOpenVehicleDetail = (marker) => {
    if (!marker) {
      this.notifyVehicleDataNotFound();
      return;
    }
    const latlng = L.latLng(marker.latitude, marker.longitude);
    // Best-effort camera move: if the projection math throws for any reason
    // (e.g. the map isn't laid out yet), it must not block the panel/circle/
    // route update below — otherwise the UI silently keeps showing whichever
    // vehicle was selected before.
    try {
      const targetZoom = this.getZoomLevel(100);
      const markerPoint = this.map.project(latlng, targetZoom);
      const offsetY = this.map.getSize().y * 0.25;
      const newCenter = this.map.unproject(
        markerPoint.subtract([0, offsetY]),
        targetZoom,
      );
      this.map.setView(newCenter, targetZoom, { animate: false });
    } catch (error) {
      console.log(error);
    }
    this.openVehicleDetailPanel(marker.vehicleData, latlng);
  };
  getDatetimeForamted(value) {
    value = value
      ? moment(value).format(DateFormat.MomentDisplayDateTimeAMPMFullFormat)
      : "";
    return value;
  }
  drawVehicleMarkers = () => {
    try {
      const activeRideId = this.openPopupRideId;
      this.isRedrawingMarkers = true;
      this.clrearVehicleMarker();
      let bounds = L.latLngBounds([]);
      let activeMarker = null;
      this.state.trackingLst.map((vehicle) => {
        if (this.hasValidVehicleLocation(vehicle)) {
          const latLng = [vehicle.vehicleLatitude, vehicle.vehicleLongitude];
          const iconUrl = this.getMarkerIconUrl(
            vehicle.hostStatus,
            vehicle.bearing,
          );

          const divIcon = L.divIcon({
            html: `<div style="position:relative;text-align:center;">
              <img src="${iconUrl}" style="width:30px;height:30px;" />
              <div style="position:absolute;top:32px;left:50%;transform:translateX(-50%);background:#eaf5fd;border:1px solid #cecece;border-radius:8px;padding:2px 10px;font-size:11px;font-weight:bold;font-family:'Segoe UI',sans-serif;color:#095590;white-space:nowrap;">
                ${vehicle.vehicleNo}
              </div>
            </div>`,
            className: "",
            iconSize: [30, 30],
            iconAnchor: [15, 15],
          });

          const marker = L.marker(latLng, { icon: divIcon }).addTo(this.map);
          marker.rideId = vehicle.rideId;
          marker.vehicleId = vehicle.vehicleId;
          marker.latitude = vehicle.vehicleLatitude;
          marker.longitude = vehicle.vehicleLongitude;
          marker.vehicleData = vehicle;

          marker.on("click", () => {
            this.centerAndOpenVehicleDetail(marker);
            this.focusListItem(vehicle.rideId);
          });

          this.vehicleMarkers.push({ marker: marker });
          bounds.extend(latLng);
          if (vehicle.rideId === activeRideId) {
            activeMarker = marker;
          }
        }
      });
      this.isRedrawingMarkers = false;
      if (activeMarker) {
        this.openVehicleDetailPanel(
          activeMarker.vehicleData,
          activeMarker.getLatLng(),
        );
      } else if (bounds.isValid()) {
        this.map.fitBounds(bounds);
      }
    } catch (err) {
      this.isRedrawingMarkers = false;
      console.log(
        "Error in " + this.displayName + ".drawVehicleMarkers function",
        err,
      );
    }
  };
  clrearVehicleMarker = () => {
    try {
      for (let i = 0; i < this.vehicleMarkers.length; i++) {
        this.vehicleMarkers[i].marker.remove();
      }
      this.vehicleMarkers = new Array();
      this.clearVehicleRadiusCircle();
    } catch (error) {}
  };
  getMarkerIconUrl = (hostStatus, bearing) => {
    let _bearing = bearing - (bearing % 5);
    let folderAndiconName = "Car";
    return (
      "../assets/img/direction/" +
      folderAndiconName +
      "/" +
      folderAndiconName +
      "_" +
      this.getColorByHostStatus(hostStatus) +
      ("_" + _bearing) +
      ".png?v=1.6"
    );
  };
  getColorByHostStatus = (hostStatus) => {
    let color = "";
    if (hostStatus === 0) {
      color = "orange";
    } else if (hostStatus === 1) {
      color = "green";
    } else if (hostStatus === 2) {
      color = "red";
    } else if (hostStatus === 3) {
      color = "orange";
    } else if (hostStatus === 4) {
      color = "blue";
    }
    return color;
  };

  // Single source of truth for "does this vehicle have a usable GPS fix" —
  // used by marker creation, the list's no-GPS badge, selection handling, and
  // the info panel's warning banner, so they can never drift out of sync.
  hasValidVehicleLocation = (vehicle) =>
    Number(vehicle?.vehicleLatitude) > 0 &&
    Number(vehicle?.vehicleLongitude) > 0;

  getTripStage = (vehicle) => {
    if (vehicle.isCancelled) {
      return { key: "cancelled", label: "Cancelled", icon: "fa-ban" };
    }
    if (vehicle.isCompleted) {
      return {
        key: "completed",
        label: "Completed",
        icon: "fa-flag-checkered",
        time: this.getDatetimeForamted(vehicle.completedTime),
      };
    }
    if (vehicle.isDeparted) {
      return { key: "active", label: "Departed", icon: "fa-route" };
    }
    if (vehicle.isBoarded) {
      return {
        key: "active",
        label: "Boarded",
        icon: "fa-user-check",
        time: this.getDatetimeForamted(vehicle.boardedTime),
      };
    }
    return null;
  };
  renderVehicleDetailPanel = () => {
    const vehicle = this.state.selectedVehicle;
    if (!vehicle) {
      return null;
    }
    const badgeColor = this.getColorByHostStatus(vehicle.hostStatus);
    const gpsDateTime = this.getDatetimeForamted(vehicle.gpsDateTime);
    const pickupDateTime = this.getDatetimeForamted(vehicle.pickupDateTime);
    const stage = this.getTripStage(vehicle);
    const hasLocation = this.hasValidVehicleLocation(vehicle);
    const initials = (vehicle.driverName || "")
      .split(/\s+/)
      .filter(Boolean)
      .map((w) => w[0])
      .join("")
      .slice(0, 2)
      .toUpperCase();
    return (
      <div
        className={`tc-info-bar${stage?.key === "cancelled" ? " tc-info-bar-cancelled" : ""}`}
      >
        <button
          type="button"
          className="tc-info-close"
          onClick={this.closeVehicleDetailPanel}
          aria-label="Close"
        >
          <i className="fas fa-times" />
        </button>
        <div className="tc-info-top">
          <div className="tc-info-id">
            <span className={`tc-status-badge tc-badge-${badgeColor}`}>
              {vehicle.tripStatusDescription}
            </span>
            <span className="tc-info-vehicle-chip">
              <i className="fas fa-car" />
              {vehicle.vehicleNo}
            </span>
            {stage && (
              <span className={`tc-info-stage tc-info-stage-${stage.key}`}>
                <i className={`fas ${stage.icon}`} />
                {stage.label}
                {stage.time ? ` · ${stage.time}` : ""}
              </span>
            )}
          </div>
          <div className="tc-info-driver">
            <div className="tc-info-avatar">
              {initials || <i className="fas fa-user" />}
            </div>
            <div className="tc-info-driver-text">
              <span className="tc-info-driver-name">
                {vehicle.driverName}
              </span>
              <span className="tc-info-driver-mobile">
                {vehicle.driverMoblieNo}
              </span>
            </div>
          </div>
          <div className="tc-info-stats">
            <div className="tc-info-stat">
              <span className="tc-info-stat-val">
                {Number(vehicle.speed ?? 0).toFixed(1)}
              </span>
              <span className="tc-info-stat-lbl">km/h</span>
            </div>
            <div className="tc-info-stat">
              <span className="tc-info-stat-val">
                {vehicle.altitude != null
                  ? Math.round(vehicle.altitude)
                  : "--"}
              </span>
              <span className="tc-info-stat-lbl">m alt</span>
            </div>
            <div className="tc-info-stat tc-info-stat-time">
              <i className="fas fa-clock" />
              <span>{gpsDateTime || "--"}</span>
            </div>
          </div>
        </div>
        {hasLocation &&
          vehicle.transactionId &&
          !vehicle.isCompleted &&
          !vehicle.isCancelled && (
          <button
            type="button"
            className="tc-live-track-btn"
            onClick={this.openLiveTracking}
          >
            <i className="fas fa-satellite-dish" />
            Live Tracking
          </button>
        )}
        {!hasLocation && (
          <div className="tc-info-warning">
            <i className="fas fa-exclamation-triangle" />
            Vehicle geo location not found
          </div>
        )}
        <div className="tc-info-bottom">
          <div className="tc-info-chip">
            <i className="fas fa-user" />
            <b>Crew</b>
            <span className="tc-info-chip-value">{vehicle.paxName}</span>
          </div>
          <div className="tc-info-chip">
            <i className="fas fa-clock" />
            <b>Pickup</b>
            <span className="tc-info-chip-value">{pickupDateTime}</span>
          </div>
          <div className="tc-info-chip">
            <i className="fas fa-map-marker-alt" />
            <b>Pick-up</b>
            <span className="tc-info-chip-value">
              {vehicle.pickupLocation}
            </span>
          </div>
          <div className="tc-info-chip">
            <i className="fas fa-flag-checkered" />
            <b>Dropoff</b>
            <span className="tc-info-chip-value">
              {vehicle.dropoffLocation}
            </span>
          </div>
        </div>
      </div>
    );
  };
  renderLiveTrackingPanel = () => {
    const vehicle = this.state.selectedVehicle;
    if (!vehicle || !this.state.showLiveTracking || !vehicle.transactionId) {
      return null;
    }
    return (
      <div className="tc-live-panel">
        <div className="tc-live-panel-header">
          <span>Live Trip Tracking · {vehicle.vehicleNo}</span>
          <button
            type="button"
            className="tc-info-close"
            onClick={this.closeLiveTracking}
            aria-label="Close"
          >
            <i className="fas fa-times" />
          </button>
        </div>
        <div className="tc-live-panel-body">
          <LiveTripTracking
            key={vehicle.transactionId}
            airlineCode={sessionStorage.getItem("session_airlineCode")}
            transactionId={vehicle.transactionId}
            employeeNumber={vehicle.employeeNo}
            height="100%"
            className="tc-live-panel-map"
            onDeparted={this.closeLiveTracking}
          />
        </div>
      </div>
    );
  };
  trackingListItemTemplate = (item) => {
    const noGps = !this.hasValidVehicleLocation(item);
    const badgeColor = this.getColorByHostStatus(item.hostStatus);
    return (
      <div className={`tc-item${noGps ? " tc-no-gps" : " tc-has-gps"}`}>
        {/* Activity header */}
        <div className="tc-item-header">
          <span className="tc-item-activity">
            <i
              className={`fas fa-${item.activityTypeId === 2 ? "map-marker-alt" : "plane fa-rotate-270"}`}
            />
            {item.activityDisplay}
          </span>
          <span className={`tc-status-badge tc-badge-${badgeColor}`}>
            {item.tripStatusDescription}
          </span>
        </div>

        {/* Vehicle chip + GPS signal */}
        <div className="tc-item-vehicle">
          <span className="tc-item-vehicle-chip">
            <i className="fas fa-car" />
            {item.vehicleNo}
          </span>
          <span
            className={`tc-gps-dot ${noGps ? "tc-gps-dot-off" : "tc-gps-dot-on"}`}
          />
          {noGps && <span className="tc-item-nogps-label">No GPS</span>}
        </div>

        {/* Secondary info mini-grid */}
        <div className="tc-item-grid">
          {item.driverName && (
            <div className="tc-item-field">
              <i className="fas fa-id-badge" />
              <span className="tc-item-field-value">{item.driverName}</span>
            </div>
          )}
          {item.gpsDateTime && (
            <div className="tc-item-field">
              <i className="far fa-clock" />
              <span className="tc-item-field-value">
                {moment(item.gpsDateTime).format(
                  DateFormat.MomentDisplayDateTimeAMPMFullFormat,
                )}
              </span>
            </div>
          )}
          {item.paxName && (
            <div className="tc-item-field">
              <i className="fas fa-user" />
              <span className="tc-item-field-value">{item.paxName}</span>
            </div>
          )}
        </div>

        {/* Footer: ride ID */}
        <div className="tc-item-footer">
          <span className="tc-item-rideid">#{item.rideId}</span>
        </div>
      </div>
    );
  };
  focusListItem = (rideId) => {
    try {
      const listInstance = this.listRef.current?.instance;
      if (!listInstance) return;
      const dataSource = listInstance.getDataSource();
      const items = dataSource.items();
      const idx = items.findIndex((item) => item.rideId === rideId);
      if (idx >= 0) {
        listInstance.selectItem(idx);
        listInstance.scrollToItem(idx);
      }
    } catch (error) {
      console.log(error);
    }
  };
  handleOnSelectVehicle = (e) => {
    try {
      const vehicle = e.itemData;
      if (!vehicle) {
        return;
      }
      if (
        !this.hasValidVehicleLocation(vehicle) ||
        !this.vehicleMarkers ||
        this.vehicleMarkers.length === 0
      ) {
        this.openVehicleDetailPanel(vehicle);
        return;
      }
      const found = this.vehicleMarkers.find(
        (m) => m.marker.rideId === vehicle.rideId,
      );
      if (!found) {
        this.openVehicleDetailPanel(vehicle);
        return;
      }
      this.centerAndOpenVehicleDetail(found.marker);
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    return (
      <>
        <style>{`
          .tc-filter-card {
            background: #ffffff;
            border: none;
            border-radius: 10px;
            box-shadow: 0 2px 12px rgba(142,100,72,0.12);
            padding: 0 !important;
            overflow: hidden;
          }
          .tc-filter-body {
            padding: 0.75rem 1rem 0.5rem;
          }
          .tc-filter-body label {
            font-size: 0.73rem;
            font-weight: 600;
            color: #8E6448;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            margin-bottom: 0.25rem;
          }
          .tc-note {
            font-size: 0.75rem;
            font-weight: 600;
            color: #8E6448;
            background: #fdf0e4;
            border-left: 3px solid #FF6600;
            border-radius: 4px;
            padding: 0.3rem 0.65rem;
            margin-bottom: 0.6rem;
            display: inline-block;
          }
          .tc-btn-search {
            background: linear-gradient(135deg, #8E6448, #b07d5c) !important;
            border: none !important;
            color: #ffffff !important;
            font-weight: 600 !important;
            font-size: 0.8rem !important;
            border-radius: 6px !important;
            padding: 0.38rem 0.9rem !important;
            transition: opacity 0.2s !important;
          }
          .tc-btn-search:hover { opacity: 0.88 !important; }
          .tc-btn-clear {
            background: #f5f0ec !important;
            border: 1px solid #d4b89a !important;
            color: #8E6448 !important;
            font-weight: 600 !important;
            font-size: 0.8rem !important;
            border-radius: 6px !important;
            padding: 0.38rem 0.9rem !important;
            transition: background 0.2s !important;
          }
          .tc-btn-clear:hover { background: #ede5dc !important; }

          /* ── Vehicle List Panel ──
             A single --tc-gutter drives the left/right inset for the header,
             search box, and every card, so they all line up on one edge —
             the previous mismatch (header padding vs. dx-list-item padding
             vs. an odd 0.05rem card margin) was what created the empty strip
             down the left side of the list.
          */
          .tc-list-panel {
            --tc-gutter: 12px;
            display: flex;
            flex-direction: column;
            height: 75.5vh;
            background: #fdf7f2;
            border-right: 1px solid #e8d5c4;
            border-radius: 8px 0 0 8px;
            overflow: hidden;
          }
          .tc-list-header {
            background: linear-gradient(135deg, #fff0e6, #fff0e6);
            padding: 0.55rem var(--tc-gutter);
            display: flex;
            align-items: center;
            gap: 0.45rem;
            flex-shrink: 0;
            border-bottom: 1px solid #e8d5c4;
            box-shadow: 0 2px 4px rgba(142, 100, 72, 0.06);
            position: relative;
            z-index: 1;
          }
          .tc-list-header span {
            color: #000000;
            font-size: 0.78rem;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-transform: uppercase;
          }
          .tc-list-header i { color: #FF6600; font-size: 0.85rem; }
          .tc-list-header .tc-list-header-count {
            margin-left: auto;
            background: #FF6600;
            color: #fff;
            font-size: 0.68rem;
            font-weight: 700;
            border-radius: 20px;
            padding: 0.08rem 0.5rem;
            letter-spacing: normal;
            text-transform: none;
          }
          .tc-list-panel .dx-list { background: transparent !important; }
          .tc-list-panel .dx-list-item {
            border-bottom: none !important;
            padding: 0 !important;
            margin: 0 !important;
          }
          /* DevExtreme wraps the rendered item in its own content box (theme
             default padding) INSIDE .dx-list-item — zeroing .dx-list-item
             above isn't enough on its own, this inner box was the real
             source of the extra left space stacking on top of --tc-gutter. */
          .tc-list-panel .dx-list-item .dx-item-content,
          .tc-list-panel .dx-list-item .dx-list-item-content {
            padding: 0 var(--tc-gutter) !important;
            margin: 0 !important;
          }
          .tc-list-panel .dx-list-item.dx-state-focused,
          .tc-list-panel .dx-list-item.dx-list-item-selected { background: transparent !important; }
          .tc-list-panel .dx-list-item.dx-state-focused .tc-item,
          .tc-list-panel .dx-list-item.dx-list-item-selected .tc-item {
            background: #eafaf1;
            box-shadow: 0 0 0 1px #a9e6c2, 0 4px 10px rgba(39, 174, 96, 0.15);
          }
          .tc-list-panel .dx-list-item.dx-list-item-selected .tc-no-gps {
            background: #fff3f3;
            box-shadow: 0 0 0 1px #f3b9b9, 0 4px 10px rgba(231, 76, 60, 0.15);
          }
          .tc-list-panel .dx-list-search {
            padding: 0 !important;
            margin: 0 !important;
          }
          .tc-list-panel .dx-searchbox {
            border-bottom: 1px solid #e8d5c4 !important;
            background: #fff8f3 !important;
            padding: 0.4rem var(--tc-gutter) !important;
            margin: 0 !important;
            box-sizing: border-box !important;
          }

          /* ── List Item Card ── */
          .tc-item {
            padding: 0.5rem 0.6rem;
            margin: 6px 0;
            cursor: pointer;
            background: #ffffff;
            border-radius: 10px;
            border-left: 4px solid #27ae60;
            box-shadow: 0 1px 3px rgba(93, 64, 40, 0.1);
            transition:
              transform 0.15s,
              box-shadow 0.15s,
              background 0.15s;
          }
          .tc-item:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 10px rgba(93, 64, 40, 0.14);
          }
          .tc-item.tc-no-gps { border-left-color: #e74c3c; background: #fffaf9; }
          .tc-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;
            row-gap: 0.2rem;
            margin-bottom: 0.3rem;
          }
          .tc-item-activity {
            font-size: 0.68rem;
            font-weight: 700;
            color: #8E6448;
            text-transform: uppercase;
            letter-spacing: 0.04em;
            display: flex;
            align-items: center;
            gap: 0.3rem;
            min-width: 0;
            max-width: 60%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex-shrink: 1;
          }
          .tc-item-activity i { color: #FF6600; flex-shrink: 0; }
          .tc-item-vehicle {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 0.4rem;
            row-gap: 0.25rem;
            margin-bottom: 0.35rem;
          }
          .tc-item-vehicle-chip {
            display: inline-flex;
            align-items: center;
            gap: 0.35rem;
            background: #fff0e6;
            color: #3d1f00;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 0.15rem 0.55rem;
            border-radius: 20px;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .tc-item-vehicle-chip i { color: #FF6600; font-size: 0.75rem; }
          .tc-gps-dot {
            width: 7px;
            height: 7px;
            border-radius: 50%;
            flex-shrink: 0;
          }
          .tc-gps-dot-on { background: #27ae60; box-shadow: 0 0 0 3px rgba(39, 174, 96, 0.18); }
          .tc-gps-dot-off { background: #e74c3c; box-shadow: 0 0 0 3px rgba(231, 76, 60, 0.18); }
          .tc-item-nogps-label {
            font-size: 0.6rem;
            color: #e74c3c;
            font-weight: 600;
          }
          .tc-item-grid {
            display: grid;
            grid-template-columns: 1fr;
            row-gap: 0.22rem;
            margin-bottom: 0.25rem;
          }
          .tc-item-field {
            display: flex;
            align-items: center;
            gap: 0.3rem;
            min-width: 0;
            font-size: 0.7rem;
            color: #7a5c48;
          }
          .tc-item-field i { color: #b07d5c; font-size: 0.68rem; flex-shrink: 0; width: 12px; text-align: center; }
          .tc-item-field-value {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .tc-item-footer {
            display: flex;
            align-items: center;
            justify-content: flex-end;
          }
          .tc-item-rideid {
            font-size: 0.65rem;
            color: #b09080;
            background: #f5ede4;
            border-radius: 4px;
            padding: 0.1rem 0.4rem;
          }
          .tc-status-badge {
            display: inline-flex;
            align-items: center;
            font-size: 0.65rem;
            font-weight: 700;
            padding: 0.12rem 0.45rem;
            border-radius: 20px;
            letter-spacing: 0.03em;
            white-space: nowrap;
            flex-shrink: 0;
          }

          .tc-badge-orange { background: #fde8d4; color: #b1590a; }
          .tc-badge-green { background: #dff5e6; color: #1e8a4c; }
          .tc-badge-red { background: #fde3e3; color: #c0392b; }
          .tc-badge-blue { background: #e0edfb; color: #1c6fc9; }
        `}</style>

        <div className="filter-box">
          <div className="card tc-filter-card p-0 m-0">
            <div className="tc-filter-body">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                  <span className="tc-note">
                    <i
                      className="fas fa-info-circle"
                      style={{ marginRight: "5px", color: "#FF6600" }}
                    ></i>
                    Note: Tracking will display only when vehicle(s) are on JOB.
                  </span>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>Airport(s)</label>
                    <SelectBox
                      dataSource={this.state.airportDropdownDataSource}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="All Airports"
                      value={this.state.airportCode}
                      displayExpr="airportName"
                      valueExpr="airportCode"
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onSelectionChanged={(e) => {
                        try {
                          let mapCenter = this.state.map;
                          let airportCode = e.selectedItem?.airportCode ?? "";
                          let latitude =
                            e.selectedItem?.latitude ?? mapCenter.center.lat;
                          let longitude =
                            e.selectedItem?.longitude ?? mapCenter.center.lng;
                          this.setState({
                            airportCode: airportCode,
                            map: {
                              center: {
                                lat: latitude,
                                lng: longitude,
                                zoom: 8,
                              },
                            },
                          });
                        } catch (error) {}
                      }}
                    />
                  </div>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3">
                  <div className="form-group">
                    <label>Transport Vendor(s)</label>
                    <SelectBox
                      dataSource={this.state.transporterDropdownDataSource}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      placeholder="All Vendors"
                      value={this.state.transporterId}
                      displayExpr="name"
                      valueExpr="id"
                      showClearButton={true}
                      disabled={false}
                      searchEnabled={true}
                      onValueChanged={(e) => {
                        this.setState((prev) => ({
                          ...prev,
                          transporterId: e.value ?? 0,
                        }));
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-lg-4 col-md-4 col-sm-4 col-xs-4"
                  style={{ marginTop: "20px" }}
                >
                  <div className="form-group">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      onClick={async () => {
                        await this.getTrackingData(
                          this.state.transporterId,
                          this.state.airportCode,
                        );
                      }}
                    >
                      <i
                        className={`fas fa-${
                          this.state.isSearch ? "spinner fa-spin" : "search"
                        }`}
                      />{" "}
                      Search
                    </button>
                    &nbsp;&nbsp;
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        try {
                          clearInterval(this.trackingRefreshInterval);
                          this.clrearVehicleMarker();
                          this.vehicleMarkers = [];
                          this.trackingRefreshInterval = null;
                          this.trackingStoreArray.length = 0;
                          this.trackingDataSource.reload();
                          this.setState((prev) => ({
                            ...prev,
                            transporterId: 0,
                            airportCode: "",
                            trackingLst: [],
                          }));
                          this.map.setZoom(this.state.map.zoom);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* end filter-box */}
        <div className="card">
          <div className="card-body-map">
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 pr-0">
                <div className="tc-list-panel">
                  <div className="tc-list-header">
                    <i className="fas fa-truck-moving" />
                    <span>Vehicles on Job</span>
                    <span className="tc-list-header-count">
                      {this.state?.trackingLst?.length ?? 0}
                    </span>
                  </div>
                  <List
                    ref={this.listRef}
                    style={this.listStyle}
                    dataSource={this.trackingDataSource}
                    keyExpr="rideId"
                    displayExpr="vehicleNo"
                    itemRender={this.trackingListItemTemplate}
                    searchEnabled={true}
                    searchExpr={this.trackingListSearchExpr}
                    searchMode="contains"
                    pageLoadMode="scrollBottom"
                    selectionMode="single"
                    selectByClick={true}
                    indicateLoading={true}
                    onItemClick={this.handleOnSelectVehicle}
                  />
                </div>
              </div>

              <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 pl-0">
                <div className="tc-map-wrap">
                  <div
                    ref={this.mapRef}
                    id="map"
                    className="tracking-map-dark"
                    style={{ height: `75.5vh`, width: `99%` }}
                  ></div>
                  {this.renderVehicleDetailPanel()}
                  {this.renderLiveTrackingPanel()}
                </div>
              </div>
            </div>
          </div>
        </div>
        <LoadPanel
          shadingColor="rgba(0,0,0,0.4)"
          position={{ of: "#root" }}
          visible={this.state.loadPanelVisible}
          showIndicator={true}
          shading={true}
          showPane={true}
          closeOnOutsideClick={false}
        />
      </>
    );
  }
}
